export default "__VITE_ASSET__pLpxalfQ__"